var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"dropdown",attrs:{"value":_vm.value,"options":_vm.options,"searchable":false,"clearable":false,"components":{ OpenIndicator: _vm.OpenIndicator }},on:{"input":function (value) { return _vm.$emit('input', value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }